import type {IFormFieldV2} from 'src/types/FormV2';
import {safeFileArrayParse} from 'src/app/forms/FormFileDropzone/utils/safeFileArrayParse';

export const CONTENT_FIELD_NAME = 'content';
export const CONTENT_PDF_FIELD_NAME = 'contentPdfUrl';
export const contentPdfField: IFormFieldV2 = {
  name: CONTENT_PDF_FIELD_NAME,
  label: 'PDF',
  type: 'file',
  required: false,
  validation: {
    maxLength: 10000,
  },
  fileUploadOptions: {
    allowMultiple: false,
    allowedFileTypes: ['application/pdf'],
    renderUploadsAsImage: true,
    simplifiedUploader: true,
    compact: true,
  },
  description: 'Optional. Add a PDF alongside the text above.',
} as IFormFieldV2;

const MEDIA_TAG = /<(img|video|iframe)\b/i;

// Rich text with embedded media is visible even when it has no text nodes.
export const hasRichTextContent = (html: unknown): boolean => {
  if (typeof html !== 'string' || html === '') return false;
  if (MEDIA_TAG.test(html)) return true;
  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;/gi, ' ')
    .trim();
  return text.length > 0;
};

export const hasContentPdf = (value: unknown): boolean =>
  safeFileArrayParse(value).length > 0;

export const hasContentBody = (
  content: unknown,
  contentPdfUrl: unknown
): boolean => hasRichTextContent(content) || hasContentPdf(contentPdfUrl);

export const excludeContentFields = (
  formMeta: IFormFieldV2[]
): IFormFieldV2[] =>
  formMeta.filter(
    field =>
      field.name !== CONTENT_FIELD_NAME && field.name !== CONTENT_PDF_FIELD_NAME
  );
